// utils.js  
import stores from '@/store/store'
import {
  Constants
} from '@/assets/js/constants';
import {
  Session
} from '@/assets/js/storage'
import {
  incomeJsonData
} from './incomeFormField.js';
import {
  assetJsonData
} from './assetFormField.js';
import {
  rulesJsonData
} from './formRules'
import {
  fieldJsonData
} from './formFields'
import {
  declarationJsonData
} from './declaration'
export function filterIncomeData(key) {
  // console.log(incomeJsonData[key])
  return incomeJsonData[key] || null;
}

export function filterAssetData(key) {
  return assetJsonData[key] || null;
}
export function filterFormRulesData(key) {
  return rulesJsonData[key] || null;
}

export function filterFormFieldsData(key) {
  return fieldJsonData[key] || null;
}

export function filterDeclarationsData(key) {
  return declarationJsonData[key] || null;
}

/**
 * 页面跳转
 * @param {*} page 即将要跳转的路由name或者组件name 
 */
export function pageChange(page) {

}



/**
 * 校验邮箱
 * @param {} email 
 * @returns 
 */
export function validateEmail(email) {
  if (!email) {
    return false;
  }
  var reg = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  if (!email.match(reg)) {
    return false;
  }
  return true;
}
/**
 * 將查詢的表單結果放入緩存
 * @param {*} formData 
 */
export function setFormDataToCache(allFormData) {

  Session.set("formId", allFormData.formId);
  if (
    allFormData.liveEmploymentInfo
  ) {
    var liveEmploymentInfo = JSON.parse(allFormData.liveEmploymentInfo)
    if (liveEmploymentInfo.hleFormData)
      //如果有獲取第一個申請者數據
      Session.set(
        "hleFormData",
        liveEmploymentInfo.hleFormData
      );
    if (liveEmploymentInfo.hleFormData2) {
      //如果有講第二申請者信息放cache
      Session.set(
        "hleFormData2",
        liveEmploymentInfo.hleFormData2
      );
    }
  }
  //申明
  if (allFormData.eligibilityDeclaration) {
    Session.set("eligibilityDeclaration", JSON.parse(allFormData.eligibilityDeclaration))
  }

  //上傳文件
  if (allFormData.fileUpload) {
    var fileUploadInfo = JSON.parse(allFormData.fileUpload)
    if (fileUploadInfo.fileUploadForm)
      //如果有獲取第一個申請者數據
      Session.set(
        "fileUploadForm",
        fileUploadInfo.fileUploadForm
      );
    if (fileUploadInfo.fileUploadForm) {
      //如果有講第二申請者信息放cache
      Session.set(
        "fileUploadForm2",
        fileUploadInfo.fileUploadForm2
      );
    }
  }
  //条款
  if (allFormData.declaretionCondition) {
    Session.set("declaretionCondition", JSON.parse(allFormData.declaretionCondition))
  }
}

/**
 * 根据页面判断当前页面属于第几个环节
 * @param {*} pageName 
 */
function getCurrentSetepNumber(pageName) {

}



// WEBPACK FOOTER //
// ./src/utils/json/utils.js